export const firebaseConfig = {
    apiKey: "AIzaSyAasiDxuSKYgGuG3QFtjqlwwDPVSf4IKSA",
    authDomain: "logos-ies-marito.firebaseapp.com",
    projectId: "logos-ies-marito",
    storageBucket: "logos-ies-marito.appspot.com",
    messagingSenderId: "236027498948",
    appId: "1:236027498948:web:0a76203b454c83a5f75491"
  };